/**
 * 小工具集合
 *
 * @version 1.0.0
 *
 */
import APIBridge from '@/utils/api-bridge'

const dateByZero = function dateByZero(datetimeText, len = 2) {
  return String(datetimeText).padStart(len, '0')
}

// 生成通用唯一识别码
const uuid = function uuid() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }

  return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4()
}

// 判断路径中是否包含协议头
const hasProtocol = function hasProtocol(url) {
  return url.match(/^https?/)
}

// 截流函数
// const throttle = function throttle(fn, interval = 30) {
//   // 第一次进行主动触发
//   // 判断是否在截流时间内，如果在，则取消后续操作（如果已经有计时器了，也会让它自动走完）
//   // 如果已超过截流时间，则重新设置一个计时器
//   let timeouterID = null
//   let init = false

//   return function(...args) {
//     // 设置一个标记，指定时间后取消
//     if (timeouterID) return

//     if (!init) {
//       fn.apply(this, args)
//       init = true
//     }

//     timeouterID = setTimeout(() => {
//       fn.apply(this, args)

//       clearTimeout(timeouterID)
//       timeouterID = null
//     }, interval)
//   }
// }

//节流函数，立刻执行，停止触发的时候再执行一次
const throttle = function throttle(func, wait) {
  let timeout
  let context
  let args
  let previous = 0

  let later = function () {
    previous = +new Date()
    timeout = null
    func.apply(context, args)
  }

  return function () {
    let now = +new Date()
    //下次触发 func 剩余的时间
    let remaining = wait - (now - previous)
    context = this
    args = arguments
    // 如果没有剩余的时间了或者你改了系统时间
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      func.apply(context, args)
    } else if (!timeout) {
      timeout = setTimeout(later, remaining)
    }
  }
}

function debounce(fn, time = 300, start = false) {
  let timer // 利用闭包函数 (存在内存中)
  return function () {
    let args = arguments
    if (start) {
      if (timer) clearTimeout(timer)
      // 重复点击清除定时器, 并重新开启计时
      else fn.apply(this, args)
      timer = setTimeout(() => {
        timer = null // 销毁 (从内存中释放)
      }, time)
    } else {
      clearTimeout(timer) // 重复点击清除定时器, 并重新开启计时
      timer = setTimeout(() => {
        fn.apply(this, args)
      }, time)
    }
  }
}

/**
 * 获取APP传来的token
 * @returns {Promise<unknown>}
 */
export const setGlobalToken = () => {
  // console.log('进入setGlobalToken  IOS: %o Android: %o', APIBridge.isIOSApp(), APIBridge.isAndroidApp())
  return new Promise((resolve) => {
    // ios立即取不到值，需要加个setTimeout
    setTimeout(() => {
      if (APIBridge.isIOSApp() || APIBridge.isAndroidApp()) {
        return Promise.all([APIBridge.getToken(), APIBridge.getSystemInfo()]).then(([tokenRes, systemInfoRes]) => {
          window.localStorage.setItem('token', tokenRes.token)
          // 系统信息
          window.localStorage.setItem('systemInfoRes', JSON.stringify(systemInfoRes))
          // 安卓留海高度
          window.localStorage.setItem('statusBarHeight', systemInfoRes.statusBarHeight)
          window.localStorage.setItem('terminalSource', systemInfoRes.terminalSource)
          /**
           * 版本号去 . ，用于判断版本
           * 3.3.1  => 331
           */
          if (systemInfoRes.v < 1000) {
            systemInfoRes.v = systemInfoRes.v * 10
          }
          window.localStorage.setItem('v', systemInfoRes.v)
          // 用户版本号
          window.localStorage.setItem('appVersion', systemInfoRes.version)
          if (!systemInfoRes.appCode) {
            console.log('进入appCodeif')
            window.localStorage.setItem('appCode', 'saas_app')
          } else {
            console.log('进入appCodeelse')
            window.localStorage.setItem('appCode', systemInfoRes.appCode)
          }

          resolve('success')
        })
      } else {
        resolve('h5')
      }
    }, 100)
  })
}
/**
 * set localhost Token
 * @constructor
 */
// function APIBridgeGetToken() {
//   return setGlobalToken()
// }
/**
 * 展示loading
 * @returns {Promise<unknown>}
 * @constructor
 */
export const APIBridgeShowLoading = () => {
  if (APIBridge.isPad()) {
    return APIBridge.showIOSLoading({
      title: '正在加载中', // 非必填
      mask: false, // （有空实现），是否显示遮罩，阻止穿透点击
    })
  }
  if (APIBridge.isAndroidApp()) {
    return APIBridge.showLoading({
      title: '正在加载中', // 非必填
      mask: true, // （有空实现），是否显示遮罩，阻止穿透点击
      // type: 1,
    })
  }
}

/**
 * 获取URL参数
 * @param {string} name - 参数名，不传则返回所有参数对象
 * @param {string} url - 指定URL，不传则默认使用当前页面URL
 * @returns {string|object|null} 参数值或参数对象
 */
export const getUrlParam = (name, url) => {
  // 默认使用当前页面URL
  const targetUrl = url || window.location.href
  console.log(targetUrl, 'targetUrl')
  // 创建URL对象
  const urlObj = new URL(targetUrl)
  const params = new URLSearchParams(urlObj.search)

  // 如果没有传入参数名，返回所有参数对象
  if (!name) {
    const result = {}
    for (const [key, value] of params) {
      result[key] = value
    }
    return result
  }

  // 返回指定参数的值
  return params.get(name)
}

/**
 * 获取数据基本类型
 * @param val
 * @returns {string}
 */
export function getType(val) {
  return Object.prototype.toString.call(val).slice(8, -1)
}
/**
 * 是否是空值
 * @param val
 * @returns {boolean}
 *
 * isEmpty() true
 * isEmpty(1) false
 */
export function isEmpty(val) {
  const type = getType(val)
  return type === 'Null' || type === 'Undefined' || val === ''
}

export default {
  dateByZero,
  uuid,
  hasProtocol,
  throttle,
  debounce,
  setGlobalToken,
  APIBridgeShowLoading,
  getUrlParam,
  isEmpty,
}
